// extracted by mini-css-extract-plugin
export default {"footerContainer":"BottomFooter_footerContainer__C2Cfy","leftContainer":"BottomFooter_leftContainer__nuim4","rightContainer":"BottomFooter_rightContainer__IMpY3"};